import BaseService from './BaseService'

class DocumentsContractsServices extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  getTempLibraryTemplateDocMapping = ({ locationId, templateId, snapshotStatusId }: { locationId: string; templateId: string, snapshotStatusId: string }) =>
    this.requests.get(`/templates/get-template-document-mapping-id/${locationId}/${templateId}/${snapshotStatusId}`)
}

const instance = new DocumentsContractsServices(BaseService.servicesConfig.DocumentContracts as string)

export default instance
